import Tippy from '@tippyjs/react';
import classNames from 'classnames';
import React, { FC, ReactElement, Ref } from 'react';
import styled from 'styled-components';

interface TooltipProps {
    overlay?: string | ReactElement;
    children: ReactElement;
    visible?: boolean;
    toolTipRef?: Ref<Element>;
    className?: string;
    isLight?: boolean;
    placement?:
        | 'top'
        | 'bottom'
        | 'right'
        | 'left'
        | 'top-start'
        | 'top-end'
        | 'bottom-start'
        | 'bottom-end'
        | 'right-start'
        | 'right-end'
        | 'left-start'
        | 'left-end'
        | 'auto'
        | 'auto-start'
        | 'auto-end';
    interactive?: boolean;
    offset?: [x: number, y: number];
    arrow?: boolean;
    theme?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

const ToolTipContentWrapper = styled.span``;

const Tooltip: FC<TooltipProps> = ({
    overlay,
    children,
    visible,
    toolTipRef,
    className,
    placement,
    isLight,
    interactive,
    offset,
    arrow = true,
    theme,
    onMouseEnter,
    onMouseLeave,
}) => {
    // check tooltip style in global style
    return (
        <Tippy
            className={classNames('tooltip', isLight && 'tooltip-light', className)}
            visible={visible}
            content={overlay}
            ref={toolTipRef}
            placement={placement}
            interactive={interactive}
            offset={offset}
            arrow={arrow}
            theme={theme}
        >
            <ToolTipContentWrapper
                ref={toolTipRef as any}
                className={classNames('tooltip-wrapper', className)}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                {children}
            </ToolTipContentWrapper>
        </Tippy>
    );
};

export { Tooltip };
